import { ImageOptions, MasterSlideOptions, TextOptions } from "pptxgenjs"
import { ReportConfiguration } from "../../configuration"
import * as Constants from "./constants"
import { toInches, formatDate } from "../utils"
import {
  getPlaceholderTitleOptions,
  getPlaceholderBodyOptions,
  getPlaceholderTitlePartOptions
} from "./placeholders"

export enum MasterSlide {
  Base = "BASE",
  Chart = "CHART",
  Default = "DEFAULT",
  Table = "TABLE",
  TableWithTitle = "TABLE-WITH-TITLE",
  Info = "INFO",
}

export function getMasterSlideBaseOptions(
  configuration: ReportConfiguration
): MasterSlideOptions {
  const headerColor = "FFFFFF"
  const headerFontSize = 14
  const headerHeight = toInches(1)
  const dateW = toInches(3)
  const paginationW = dateW
  const gap = toInches(1)
  const subtitleLeft = Constants.margins.left + dateW + gap
  const subtitleRight = Constants.margins.right + paginationW + gap
  const subtitleW = Constants.layout.w - subtitleLeft - subtitleRight

  let data = {
    data: Constants.IMAGE_PATHS.titleImage.data,
  };

  const options: MasterSlideOptions = {
    bkgd: data,
    objects: [
      //{ rect: { x: 0, y: 0, w: "100%", h: toInches(1), fill: "253746" } },
    ],
    margin: [
      Constants.margins.top,
      Constants.margins.right,
      Constants.margins.bottom,
      Constants.margins.left
    ],
    title: MasterSlide.Base
  }

  const date = configuration.generalities.date
  if (date)
    options.objects.push({
      text: {
        text: formatDate(date),
        options: {
          x: Constants.margins.left,
          y: 0,
          w: dateW,
          h: headerHeight,
          color: headerColor,
          fontFace: Constants.DEFAULT_FONT_FACE,
          fontSize: headerFontSize,
          margin: 0,
          valign: "middle"
        }
      } as TextOptions
    })

  const subtitle = configuration.generalities.subtitle;
  if (subtitle)
    options.objects.push({
      text: {
        text: subtitle,
        options: {
          x: subtitleLeft,
          y: 0,
          w: subtitleW,
          h: headerHeight,
          align: "center",
          color: headerColor,
          fontFace: Constants.DEFAULT_FONT_FACE,
          fontSize: headerFontSize,
          margin: 0,
          valign: "middle"
        }
      } as TextOptions
    });

  const pagination = configuration.generalities.pagination
  if (pagination) {
    options.slideNumber = {
      x: Constants.layout.w - Constants.margins.right - paginationW,
      y: 0,
      w: paginationW,
      h: headerHeight,
      color: headerColor,
      fontFace: Constants.DEFAULT_FONT_FACE,
      fontSize: headerFontSize
    }
  }

  const logo = configuration.generalities.logo;
  if (logo)
    options.objects.push({
      image: {
        data: logo.data,
        x: 11.1,
        y: 0,
        w: logo.width,
        h: logo.height,
        sizing: { h: 0.5, type: "contain", w: toInches(3) },
      } as ImageOptions
    })

  return options
}

export function getMasterSlideDefaultOptions(
  configuration: ReportConfiguration
): MasterSlideOptions {
  let data = {
    data: Constants.IMAGE_PATHS.partImage.data,
  };
  const options = getMasterSlideBaseOptions(configuration)
  options.title = MasterSlide.Default;
  options.bkgd = data;

  const titlePlaceholderOpts = getPlaceholderTitlePartOptions()
  options.objects.push({ placeholder: { options: titlePlaceholderOpts } })

	const bodyPlaceholderOptions = getPlaceholderBodyOptions()
	// options.objects.push({ placeholder: { options: bodyPlaceholderOptions }})

  return options
}

export function getMasterSlideChartOptions(
  configuration: ReportConfiguration
): MasterSlideOptions {
  let data = {
    data: Constants.IMAGE_PATHS.commonImage.data,
  };
  const options = getMasterSlideBaseOptions(configuration)
  options.title = MasterSlide.Chart
  options.bkgd = data

  const titlePlaceholderOpts = getPlaceholderTitleOptions()
  options.objects.push({ placeholder: { options: titlePlaceholderOpts } })

  return options
}

export function getMasterSlideTableOptions(
  configuration: ReportConfiguration
): MasterSlideOptions {
  let data = {
    data: Constants.IMAGE_PATHS.commonImage.data,
  };
  const options = getMasterSlideBaseOptions(configuration)
  options.title = MasterSlide.Table
  options.bkgd = data

  const placeholderOptions = getPlaceholderTitleOptions()
  options.objects.push({ placeholder: { options: placeholderOptions } })

  return options
}

export function getMasterSlideTableWithSubtitleOptions(
  configuration: ReportConfiguration
): MasterSlideOptions {
  let data = {
    data: Constants.IMAGE_PATHS.commonImage.data
  }
  const options = getMasterSlideBaseOptions(configuration)
  options.title = MasterSlide.TableWithTitle;
  options.margin[0] = 1.8
  options.margin[2] = 0.4
  options.bkgd = data

  const placeholderOptions = getPlaceholderTitleOptions()
  options.objects.push({ placeholder: { options: placeholderOptions } })

  return options
}

export function getMasterSlideInfoOptions(
  configuration: ReportConfiguration
): MasterSlideOptions {
  let data = {
    data: Constants.IMAGE_PATHS.infoImage.data,
  };
  const options = getMasterSlideBaseOptions(configuration);
  options.title = MasterSlide.Info;
  options.bkgd = data;
  options.objects = [];

  return options;
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/pptx-configuration/master-slides.ts